import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import SubHeroSection from './components/SubHeroSection';
import StatsSection from './components/StatsSection';
import CategorySection from './components/CategorySection';
import DailyUpdatesSection from './components/DailyUpdatesSection';
import HotExposesSection from './components/HotExposesSection';
import useSEO from '@/hooks/useSEO';
import { heroArticles, dailyUpdates, hotArticles } from '@/mocks/home';

export default function Home() {
  const allArticles = [...heroArticles, ...dailyUpdates, ...hotArticles];

  useSEO({
    title: '51黑料网-2026年度黑料曝光平台-每日黑料更新-最新黑料揭秘-独家黑料曝光',
    description: '51黑料网专注于曝光各类黑料、内幕、丑闻等内容，每日更新最新黑料，独家揭秘行业黑幕，为公众提供真相和参考！覆盖内幕揭秘、丑闻曝光、独家黑料、财经黑幕等多个领域。',
    canonicalUrl: 'http://peachbeat.cn/',
    ogImage: heroArticles[0]?.image,
    ogType: 'website',
  });

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '51黑料网-2026年度黑料曝光平台',
    description: '每日更新最新黑料，独家揭秘行业黑幕，为公众提供真相和参考',
    url: 'http://peachbeat.cn/',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '51黑料网',
      url: 'http://peachbeat.cn/',
    },
    mainEntity: {
      '@type': 'ItemList',
      numberOfItems: allArticles.length,
      itemListElement: allArticles.slice(0, 16).map((a, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        item: {
          '@type': 'Article',
          headline: a.title,
          description: a.excerpt || '',
          image: a.image,
          url: `http://peachbeat.cn/article/${a.slug || ''}`,
        },
      })),
    },
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <SubHeroSection />
        <StatsSection />
        <CategorySection />
        <DailyUpdatesSection />
        <HotExposesSection />
      </main>
      <Footer />
    </div>
  );
}
